"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_pdf_1 = require("react-pdf");
var ui_1 = require("@aperza/ui");
var PdfEditorView_module_scss_1 = __importDefault(require("./PdfEditorView.module.scss"));
var PdfEditorProvider_1 = require("./PdfEditorProvider");
var RotationButtons_1 = require("../pdf/RotationButtons");
var pdfjs = require('react-pdf').pdfjs;
// use jsdelivr instead of static.aperza.com (to avoid maintaining 23), plus jsdelivr has more cdn's
var pdfJsRootPath = "https://cdn.jsdelivr.net/npm/pdfjs-dist@" + pdfjs.version;
pdfjs.GlobalWorkerOptions.workerSrc = pdfJsRootPath + "/build/pdf.worker.min.js";
var documentOptions = {
    cMapUrl: pdfJsRootPath + "/cmaps/",
    cMapPacked: true,
};
exports.PdfEditorView = function (_a) {
    var pdfSource = _a.pdfSource, disableClickRotate = _a.disableClickRotate;
    var pdfViewDivRef = react_1.useRef(null);
    var _b = PdfEditorProvider_1.usePdfEditorContext(), pdfDoc = _b.pdfDoc, setLoading = _b.setLoading, setPageLoading = _b.setPageLoading, showEditor = _b.showEditor, pageNumber = _b.pageNumber, initActivePages = _b.initActivePages, rotationAngle = _b.rotationAngle, prevRotationAngle = _b.prevRotationAngle, initPageRotationAngle = _b.initPageRotationAngle, rotateRight = _b.rotateRight, prevPdfEditorViewDimension = _b.prevPdfEditorViewDimension, setPdfEditorViewDimension = _b.setPdfEditorViewDimension, pdfScale = _b.pdfScale;
    var getPdfViewWidth = function () {
        var _a;
        if (pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) {
            return (_a = pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        }
        return 0;
    };
    var getPdfViewHeight = function () {
        var _a;
        if (pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) {
            return (_a = pdfViewDivRef === null || pdfViewDivRef === void 0 ? void 0 : pdfViewDivRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        }
        return 0;
    };
    var updatePdfEditorViewDimension = function () {
        var pdfViewWidth = getPdfViewWidth();
        var pdfViewHeight = getPdfViewHeight();
        var prevWidth = prevPdfEditorViewDimension === null || prevPdfEditorViewDimension === void 0 ? void 0 : prevPdfEditorViewDimension.width;
        var prevHeight = prevPdfEditorViewDimension === null || prevPdfEditorViewDimension === void 0 ? void 0 : prevPdfEditorViewDimension.height;
        var xScale = pdfViewWidth / (prevWidth || pdfViewWidth);
        var yScale = pdfViewHeight / (prevHeight || pdfViewHeight);
        setPdfEditorViewDimension({ width: pdfViewWidth, height: pdfViewHeight });
    };
    react_1.useEffect(function () {
        setLoading(true);
        setPageLoading(true);
    }, [pdfSource]);
    /**
     * To ensure that the editor is sized properly.
     * When showEditor is false, the editor is hidden thus the editor dimension may not be updated.
     */
    react_1.useEffect(function () {
        if (showEditor) {
            updatePdfEditorViewDimension();
        }
    }, [showEditor]);
    var onDocumentLoadSuccess = function (doc) {
        if (doc.numPages > 0) {
            initActivePages(doc.numPages);
        }
        pdfDoc.current = doc;
        setLoading(false);
    };
    var onPageLoadSuccess = function (page) {
        setPageLoading(true);
        initPageRotationAngle(page.pageNumber, page.rotate);
    };
    var onPageRenderSuccess = function (page) {
        if (page.pageNumber === pageNumber) {
            if (prevRotationAngle === rotationAngle) {
                updatePdfEditorViewDimension();
            }
            else {
                updatePdfEditorViewDimension();
            }
            setPageLoading(false);
        }
    };
    var onPageClickRotation = function (ref) {
        if (ref && !disableClickRotate) {
            // @ts-ignore
            // eslint-disable-next-line no-param-reassign
            ref.onclick = function () {
                rotateRight();
            };
            // @ts-ignore
            // eslint-disable-next-line no-param-reassign
            ref.style.cursor = RotationButtons_1.CURSOR_SVG;
        }
    };
    var resize = function () {
        var pdfViewWidth = getPdfViewWidth();
        var pdfViewHeight = getPdfViewHeight();
        updatePdfEditorViewDimension();
    };
    ui_1.useWindowResize(resize);
    return (react_1.default.createElement("div", { ref: pdfViewDivRef, className: PdfEditorView_module_scss_1.default.wrapper },
        react_1.default.createElement(react_pdf_1.Document, { file: pdfSource, onLoadSuccess: onDocumentLoadSuccess, options: documentOptions }, pageNumber && ( // render page after the doc has been loaded.
        react_1.default.createElement(react_pdf_1.Page, { className: PdfEditorView_module_scss_1.default.page, pageNumber: pageNumber, renderAnnotationLayer: false, renderTextLayer: false, onLoadSuccess: onPageLoadSuccess, 
            // @ts-ignore
            onRenderSuccess: onPageRenderSuccess, inputRef: onPageClickRotation, rotate: rotationAngle, scale: pdfScale })))));
};
exports.PdfEditorView.displayName = 'PdfEditorView';
//# sourceMappingURL=PdfEditorView.js.map